/** Re-read a query for a recovery (a reload, a conflict or lost-connection recovery) and return what the daemon
 *  answered. Pass the hook's own `refetch`. A failed read rejects, and so does an answer without data, so a
 *  recovery never claims to have verified a state it did not read. */
export async function rereadQuery<T>(refetch: (options: { throwOnError: true }) => Promise<{ data: T | undefined }>): Promise<T> {
  const { data } = await refetch({ throwOnError: true });
  if (data === undefined) throw new Error('The re-read returned no data.');
  return data;
}
